import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Report } from './types';

/**
 * Generate and download an .xlsx from a report table — client-side, using the same
 * libraries the app's Reports pages use (xlsx + file-saver). No backend/file storage.
 */
const downloadReportAsExcel = (report: Report): void => {
  const aoa = [report.columns, ...report.rows];
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Report');
  const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, `${report.filename || 'workflows-report'}.xlsx`);
};

export default downloadReportAsExcel;
